export default function About() {
  return (
    <section className="border-t border-surface-border px-5 py-14 sm:px-12 sm:py-20">
      <h2 className="text-3xl font-bold mb-2 sm:text-4xl sm:mb-3">
        <span className="text-gradient">Professional Summary</span>
      </h2>
      <p className="max-w-3xl text-gray-300 text-base leading-relaxed sm:text-lg">
        Full-Stack Developer with hands-on experience building scalable web applications using{" "}
        <span className="text-accent-cyan">Java</span>,{" "}
        <span className="text-accent-cyan">Spring Boot</span>,{" "}
        <span className="text-accent-violet">Node.js</span>,{" "}
        <span className="text-accent-violet">React</span>,{" "}
        <span className="text-accent-violet">Next.js</span> and{" "}
        <span className="text-accent-cyan">AWS</span>. Experienced in AI-powered application development using{" "}
        <span className="text-accent-violet">Amazon Bedrock</span>, cloud-native backend systems, RESTful APIs and production debugging.
        Strong foundation in Data Structures & Algorithms, Object-Oriented Programming, SQL, system design fundamentals and modern software engineering practices.
      </p>
    </section>
  );
}
